<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZYWxmc/images/9780446558563.jpg?1733085690285" alt="This image is the cover for the book Seduced by a Rogue, Galloway Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seduced by a Rogue, Galloway Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <p>A fair-haired beauty at 19, Lady Mairi is heiress apparent to her father Lord Dunwythie's rich barony. He has carefully taught her how to manage their estates, but a feud between his clan and the Maxwell clan is brewing as the two families edge toward a clan war - their dispute over money owed.  Mairi's father believes he owes nothing, and of course Mairi sides with him.<br/><br/> When the impulsive and blue-eyed Rob Maxwell chances to meet Mairi in a barley field, they feel instant attraction, despite their families' antagonisms.  Knowing he must put his clan first, Rob enacts a plan to force Dunwythie to pay his debt:  Rob kidnaps Mairi, making the abduction appear the work of a stranger; then he and his sheriff-brother offer to help Dunwythis rescue his daughter IF, and only if, he will pay them the monies due. Yet after Rob captures Mairi's body, she captures his heart. When Dunwythie summons the aid of the most powerful clan in all Scotland (the Douglases), clan-tensions rise to a fever pitch. Love takes its own feverish course, as Mairi and Rob join forces to prevent a clash between hot-headed clans, and to protect their budding love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Scott
      </h2>
      
      <p class="authorDescription body article">&amp;lt;DIV&amp;gt;&amp;lt;B&amp;gt;Amanda Scott&amp;lt;/B&amp;gt; is the author of over 62 romance novels and the recipient of the Romance Writers of America's prestigious RITA Award. She lives in Folsom, California, outside of Sacramento. She is a fourth-generation Californian.&amp;lt;/DIV&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d358fb74